import React from "react";
import { Box, Card, Divider, Typography, Button, Stack } from "@mui/material";
import styles from "./cisoDashboard.module.scss";

const exposureStats = [
  { label: "Known Attack Patterns", value: "1,247" },
  { label: "AI Models Deployed", value: "23" },
  { label: "Coverage Rate", value: "88%" },
];

export const ThreatExposureAnalysis = ({ handleNavigate }) => {
  return (
    <Card
      className={styles.card}
      sx={{ width: "100%" }}
      variant="outlined"
      elevation={0}
    >
      <Typography className={styles.sectionHeading} fontWeight={600}>
        Threat Exposure Analysis
      </Typography>
      <Typography className={styles.subtitle} sx={{ mt: 0.5 }}>
        AI Coverage & Detection Gaps
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="text.secondary">
          Attack Patterns Not Covered
        </Typography>
        <Typography variant="h5" fontWeight={700} color="#0CA6F2">
          12%
        </Typography>
      </Box>
      <Box
        className={styles.progressBar}
        style={{ marginTop: 10, height: "14px" }}
      >
        <Box
          className={styles.progressFill}
          sx={{
            width: "12%",
            height: "14px",
            background: "linear-gradient(90deg, #0CA6F2, #7ce4ff)",
          }}
        />
      </Box>
      <Stack direction="column" justifyContent={"space-between"} gap={1}>
        {" "}
        {exposureStats.map((item) => (
          <Stack
            key={item.label}
            direction="row"
            gap={1}
            justifyContent={"space-between"}
          >
            <Typography className={styles.subtitle}>{item.label}</Typography>
            <Typography fontWeight={700}>{item.value}</Typography>
          </Stack>
        ))}
      </Stack>
      <Button
        variant="contained"
        className={styles.ctaButton}
        onClick={() => handleNavigate("ai-contextualization-report")}
        sx={{ borderRadius: 2, bgcolor: "rgba(5, 117, 230, 1)" }}
      >
        View AI Contextualization Report
      </Button>
    </Card>
  );
};

export default ThreatExposureAnalysis;
